import React, { useEffect, useRef } from 'react'
import Lottie from 'lottie-web';
import surpriseAnimationData from '../../assets/lottie/55158-surprise-gift-box.json';
import confettiAnimationData from '../../assets/lottie/58295-confetti.json';

export default function WinPriceModal(props) {

  const surpriseContainerRef = useRef(null);
  const supriseAnimationRef = useRef(null);

  const confettiContainerRef = useRef(null);
  const confettiAnimationRef = useRef(null);

  useEffect(() => {
    if (props.isOpen === true) {
      document.getElementById("openWinningModal").click();
    }
  }, [props])


  const toggleModal = () => {
    props.setIsOpen(false);
  }


  useEffect(() => {
    supriseAnimationRef.current = Lottie.loadAnimation({
      container: surpriseContainerRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: surpriseAnimationData,
    });


    confettiAnimationRef.current = Lottie.loadAnimation({
      container: confettiContainerRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: confettiAnimationData,
    })


    return () => {
      supriseAnimationRef.current.destroy();
      confettiAnimationRef.current.destroy();
    };
  }, []);


  return (
    <>
      <button type="button" className="btn btn-primary d-none" id="openWinningModal" data-bs-toggle="modal" data-bs-target="#exampleModal">
        Launch demo modal
      </button>

      <div className="modal fade" id="exampleModal" tabIndex="-1" data-bs-backdrop="static" data-bs-keyboard={false} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-0 pb-2">
            <div className="modal-header border-0 pb-0">
              {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => toggleModal()}></button> */}
            </div>
            <div className="modal-body text-center pt-0 px-3">

              <div className='position-relative'>

                {/* <div
            ref={confettiContainerRef}
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'absolute'
            }}
          />  */}

                <div
                  ref={surpriseContainerRef}
                  style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                />
              </div>


              <h2 className='futura-bold text-uppercase'>{props?.prizeTitle}</h2>
              <h4 className='text-secondary futura-medium'>
                {props?.prizeMessage?.split('\\n').map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    {index !== props.prizeMessage.split('\\n').length - 1 && <br />}
                  </React.Fragment>
                ))}
              </h4>
              <a href="https://daptoleagues.com.au/easter-at-dlc" className="btn btn-primary mt-4" onClick={() => toggleModal()}>Raffle Info</a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
